
var initializeHouseSearchFilter = function() {
	$( ".filter-tabs" ).tabs();

	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		$(this).toggleClass("openFilter");
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.resultLeft,.pop-sorting').hide();
		return false;
	});
}
